<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <p>Export list of all Scheduled Pickups</p>
        <el-form
          ref="form"
          :model="form"
          size="small"
        >
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Export
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Scheduled Pickups Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
      :is-direct-download="true"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      pageTitle: 'Scheduled Pickups',
      breadcrumb: {
        name: 'Scheduled Pickups',
        route: { name: 'reports-scheduled-pickups' }
      },
      form: {},
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    downloadCSV () {
      this.configuration = {
        report: 'ScheduledPickups',
        params: this.form
      }
      this.isShowPreview = true
    }
  }
}
</script>
